import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getDateFormat } from '../../common/common';

class Success extends Component {
    constructor(props){
        super(props);
        this.state = {
            
        }
    }

    home = () => {
        window.location.href = "/"
    }

    editSuccess = () => {
        let editPolicyDetails = this.props.editPolicy;
        let APIGetBookingDetailsResult = editPolicyDetails.data.APIGetBookingDetailsResult[0];
        let fromCityName = APIGetBookingDetailsResult.FromCityName;
        let toCityName = APIGetBookingDetailsResult.ToCityName;
        //let opName = APIGetBookingDetailsResult.CompanyName;
        //let busType = APIGetBookingDetailsResult.BusType;
        let PaxDetail = APIGetBookingDetailsResult.PaxDetail;
        let email = editPolicyDetails.editDetails.PaxEmail ? editPolicyDetails.editDetails.PaxEmail : APIGetBookingDetailsResult.PassengerEmail;
        let phone = editPolicyDetails.editDetails.PaxMobile ? editPolicyDetails.editDetails.PaxMobile : APIGetBookingDetailsResult.PassengerContactNo1;
        let pnrNo = APIGetBookingDetailsResult.PNRNo;
        let departureTime = getDateFormat(APIGetBookingDetailsResult.DptTime);
        let arrivalTime = getDateFormat(APIGetBookingDetailsResult.ArrivalTime);
        let pick = editPolicyDetails.editDetails.pickup && editPolicyDetails.editDetails.pickup;
        let pickUpName = pick ? pick.PickupName : APIGetBookingDetailsResult.PickupName;
        let pickUpAddress = pick ? pick.Address : APIGetBookingDetailsResult.PickupAddress;
        let pickUpLandmark = pick ? pick.Landmark : APIGetBookingDetailsResult.PickupLandmark;
        let drop = editPolicyDetails.editDetails.dropoff && editPolicyDetails.editDetails.dropoff;
        let dropOffName = drop ? drop.DropoffName : APIGetBookingDetailsResult.DropoffName;
        return(
            <div>
                <div className='top-wrapper' style={{background: window.color['searchBoxBgColor']}}>
                    <span className='header-title'>
                        Edit Booking
                    </span>
                </div>
                <div className='ep-wrapper' style={{zIndex:'100'}}>
                    <div className='updatedDetails-text'>
                        Your information changed successfully. Please check your updated booking details below.
                    </div>
                    <div className='success-wrapper'>
                        <div className='opDetails-wrapper' style={{marginBottom:'15px'}}>
                            <div className='opDetail'>
                                <div>{fromCityName}, {departureTime}</div>
                                <div>{toCityName}, {arrivalTime}</div>
                            </div>
                            {/*<div className='opDetail'>
                                <p>Operator</p>
                                <div>{ opName }</div>
                                <div>{ busType }</div>
                            </div>*/}
                            <div className='opDetail'>
                                <p>PNR</p>
                                <div>{ pnrNo }</div>
                            </div>
                            <div className='opDetail'>
                                <p>Boarding Point</p>
                                <div>{ pickUpName }, { pickUpAddress }, { pickUpLandmark }</div>
                            </div>
                            <div className='opDetail'>
                                <p>Dropping Point</p>
                                <div>{ dropOffName }</div>
                            </div>
                            <div className='opDetail'>
                                <p>Email</p>
                                <div>{ email }</div>
                            </div>
                            <div className='opDetail'>
                                <p>Phone</p>
                                <div>{ phone }</div>
                            </div>
                        </div>
                        
                        <div style={{paddingBottom:'10px'}}>Passenger Details</div>
                        <div className='opDetails-wrapper'>
                            <table cellPadding='5px' cellSpacing='5px'>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Age</th>
                                        <th>Gender</th>
                                        <th>Seat</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { PaxDetail.map((el, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{el.PaxName}</td>
                                                <td>{el.Age}</td>
                                                <td>{el.Gender}</td>
                                                <td>{el.SeatNo}</td>
                                            </tr>
                                        )
                                    }) }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className='btn' style={{background:window.color['buttonColor'],position:'fixed',left:'0',right:'0',bottom:'0'}} onClick={()=>this.home()} >
                            GET BACK HOME
                    </div>
                </div>
            </div>
        )
    }

	render() {
    	return (
    		<div>
				{ this.editSuccess() }
			</div>
    	)
  	}
}

const mapStateToProps = function(store) {
    return (store);
};

export default connect(mapStateToProps)(Success);


// WEBPACK FOOTER //
// ./src/components/editSuccess/EditSuccess.js